import { Box, IconButton, ListItemButton } from "@mui/material"
import { useDialog } from "lib/@hooks/useDialog"
import { ListItemBox } from "lib/@components/ListItemBox"
import { BlockClicks } from "lib/@components/block-clicks"
import { confirm } from "lib/@dialogs/confirm"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import Iconify from "minimals-template/components/Iconify"
import { deleteBundle, updateBundle } from "../controller/auth-bundles.controller"
import { AuthBundleDialog } from "./auth-bundle-dialog"

export function AuthBundleRow({ item: bundle }) {
    const edit = useDialog(<AuthBundleDialog bundle={bundle} />, { maxWidth: "md", fullWidth: true })

    return (
        <ListItemButton onClick={modify}>
            <ListItemBox data-cy={`auth-bundle-item-${bundle.name.replaceAll(" ", "")}`}>
                {bundle.name}
                <Box flex={1} />
                <BlockClicks>
                    <IconButton
                        aria-label="Remove bundle"
                        color="secondary"
                        onClick={remove}
                        data-cy="auth-bundle-delete-button"
                    >
                        <Iconify icon="mdi:delete" />
                    </IconButton>
                </BlockClicks>
            </ListItemBox>
        </ListItemButton>
    )

    async function modify() {
        const update = await edit(bundle)
        if (update) {
            try {
                update.id = bundle._id
                await updateBundle(update)
                successSnackbar("Bundle updated")
            } catch (error) {
                console.error(error)
                errorSnackbar(error?.toString())
            }
        }
    }

    async function remove() {
        if (await confirm("Are you sure you want to remove the bundle?", "Remove Bundle")) {
            try {
                await deleteBundle({ id: bundle._id })
                successSnackbar("Bundle removed")
            } catch (error) {
                console.error(error)
                errorSnackbar(error?.toString())
            }
        }
    }
}
